export default __webpack_public_path__ + "b726acbfa0b2d520f6025326a29f1f8a.svg";